"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8916],{

/***/ 68916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Relative/Relative.js
var Relative = __webpack_require__(70564);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Absolute/Absolute.js
var Absolute = __webpack_require__(7981);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Shimmer/Shimmer.js
var Shimmer = __webpack_require__(38201);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/ramda/es/isEmpty.js + 1 modules
var isEmpty = __webpack_require__(50774);
// EXTERNAL MODULE: ./node_modules/ramda/es/join.js
var join = __webpack_require__(58493);
// EXTERNAL MODULE: ./node_modules/ramda/es/keys.js
var keys = __webpack_require__(79898);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(37138);
// EXTERNAL MODULE: ./node_modules/@pcln/experimentation/dist/esm/index.js + 4 modules
var esm = __webpack_require__(80460);
// EXTERNAL MODULE: ./node_modules/@pcln/date-picker/dist/esm/index.js + 92 modules
var dist_esm = __webpack_require__(76339);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/react-hook-form.es.js
var react_hook_form_es = __webpack_require__(63523);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/react-stickynode/dist/Sticky.js
var Sticky = __webpack_require__(27430);
var Sticky_default = /*#__PURE__*/__webpack_require__.n(Sticky);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Pin.js
var Pin = __webpack_require__(28387);
// EXTERNAL MODULE: ./src/utils/date-helper.tsx
var date_helper = __webpack_require__(68511);
// EXTERNAL MODULE: ./src/components/SearchFormButton/index.tsx
var SearchFormButton = __webpack_require__(17975);
// EXTERNAL MODULE: ./src/components/TypeAhead/index.tsx + 13 modules
var TypeAhead = __webpack_require__(21993);
// EXTERNAL MODULE: ./src/components/Popover.tsx + 2 modules
var Popover = __webpack_require__(57812);
// EXTERNAL MODULE: ./src/components/ShadowEffect.tsx
var ShadowEffect = __webpack_require__(10843);
// EXTERNAL MODULE: ./src/components/CalenderWrapperBox.styled.ts
var CalenderWrapperBox_styled = __webpack_require__(2850);
// EXTERNAL MODULE: ./src/components/DateField.tsx
var DateField = __webpack_require__(43484);
// EXTERNAL MODULE: ./src/components/TravelerSelection/TravelerSelection.tsx + 9 modules
var TravelerSelection = __webpack_require__(47941);
// EXTERNAL MODULE: ./src/components/TravelerSelection/constants.ts
var constants = __webpack_require__(45588);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/hooks/useTabGroup.ts
var useTabGroup = __webpack_require__(78474);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
;// CONCATENATED MODULE: ./src/components/StickyEffect.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div {\n    left: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StickyNode = (0,styled_components_browser_esm/* default */.ZP)((Sticky_default())).withConfig({
    componentId: "sc-7e08f4d0-0"
})(_templateObject());
function StickyEffect(param) {
    var children = param.children, handleStickyEffectStateChange = param.handleStickyEffectStateChange, enabled = param.enabled, isStickyInEffect = param.isStickyInEffect, _stickyHeight = param.stickyHeight, stickyHeight = _stickyHeight === void 0 ? 80 : _stickyHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyNode, {
        enabled: enabled,
        innerZ: 1,
        onStateChange: handleStickyEffectStateChange,
        enableTransforms: false,
        children: isStickyInEffect ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            textAlign: "center",
            width: "100vw",
            pb: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                color: "text.base",
                boxShadowSize: "xl",
                bg: "background.lightest",
                borderRadius: "3xl",
                borderWidth: 0,
                rounded: "bottom",
                display: "inline-block",
                width: [
                    1,
                    null,
                    null,
                    null,
                    null,
                    1280
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: 1280,
                    stickyHeight: stickyHeight,
                    p: 4,
                    pt: 3,
                    pb: 0,
                    children: children
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                borderWidth: "0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: children
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/BundleAndSave/BundleAndSave.tsx
var BundleAndSave = __webpack_require__(18103);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/utils/packages-room-count.ts
var packages_room_count = __webpack_require__(40753);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./src/components/Hotels/constants.ts
var Hotels_constants = __webpack_require__(69722);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
;// CONCATENATED MODULE: ./src/hooks/useCityNameInBtnTextExperiment.ts





var getCityNameBtnTextFromLocation = function(location) {
    return !!(location === null || location === void 0 ? void 0 : location.cityName) && (location === null || location === void 0 ? void 0 : location.type) === "CITY" ? "Find ".concat(location.cityName, " Hotels") : null;
};
var SUBMIT_BTN_TEXT = "Find Your Hotel";
function useCityNameInBtnTextExperiment(tripType, endLocation) {
    var ref;
    var ref1 = (0,react.useContext)(BootstrapDataContext/* default */.Z), isMobile = ref1.isMobile, prePopData = ref1.prePopData;
    var prePopEndLocation = prePopData === null || prePopData === void 0 ? void 0 : (ref = prePopData.hotels) === null || ref === void 0 ? void 0 : ref.endLocation;
    var hasCityInPrePop = !!(prePopEndLocation === null || prePopEndLocation === void 0 ? void 0 : prePopEndLocation.cityName) && (prePopEndLocation === null || prePopEndLocation === void 0 ? void 0 : prePopEndLocation.type) === "CITY";
    var pathname = (0,router.useRouter)().pathname;
    var hotelsPage = pathname === "/hotels";
    var isMobileHotelsLP = hotelsPage && isMobile;
    var isCityNameBtnTextTestInVariant = (0,useSeti/* default */.Z)("HOTELS_LP_SEM_CITY_BUTTON", isMobileHotelsLP && hasCityInPrePop) === "VARIANT";
    var allowCityNameBtnText = isMobileHotelsLP && hasCityInPrePop && isCityNameBtnTextTestInVariant;
    var ref2 = (0,react.useState)(allowCityNameBtnText && getCityNameBtnTextFromLocation(endLocation) || SUBMIT_BTN_TEXT), searchBtnText = ref2[0], setSearchBtnText = ref2[1];
    var hasFlight = tripType.includes(Hotels_constants/* FLY */.wd);
    (0,react.useEffect)(function() {
        setSearchBtnText(allowCityNameBtnText && !hasFlight && getCityNameBtnTextFromLocation(endLocation) || SUBMIT_BTN_TEXT);
    }, [
        endLocation,
        hasFlight,
        allowCityNameBtnText
    ]);
    return searchBtnText;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@pcln/request/dist/esm/index.js
var request_dist_esm = __webpack_require__(37947);
var esm_default = /*#__PURE__*/__webpack_require__.n(request_dist_esm);
// EXTERNAL MODULE: ./node_modules/isomorphic-config/lib/config.js
var config = __webpack_require__(82197);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/hooks/useFetchCityMap.ts






var useFetchCityMap = function(param) {
    var lat = param.lat, lon = param.lon, width = param.width, height = param.height;
    var ref = (0,react.useState)(""), cityMapURL = ref[0], setCityMapURL = ref[1];
    var fetchCityMap = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var cityLat, cityLon, cityMapWidth, cityMapHeight, ref, ref1, ref2, ref3, url, timeout, result, ref4, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        cityLat = param.lat, cityLon = param.lon, cityMapWidth = param.width, cityMapHeight = param.height;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        ref3 = (config_default()).client["pcln-graph"], url = ref3.url, timeout = ref3.timeout;
                        return [
                            4,
                            esm_default()({
                                url: url,
                                timeout: timeout,
                                method: "POST",
                                data: {
                                    query: "query ($lat: Float!, $lon: Float!, $x: Int!, $y: Int!){ \n                    googleMapStatic(\n                      center:{ lat: $lat, lon: $lon },\n                      size: { x: $x, y: $y}\n                    ) {\n                      url\n                    }\n                  }",
                                    variables: {
                                        lat: cityLat,
                                        lon: cityLon,
                                        x: cityMapWidth,
                                        y: cityMapHeight
                                    }
                                }
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        setCityMapURL((ref4 = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.googleMapStatic) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref4 !== void 0 ? ref4 : "");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        analytics/* default.logError */.Z.logError({
                            message: "Failed to load city map url"
                        });
                        setCityMapURL("None");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        if (lat !== undefined && lon !== undefined && height !== undefined && width !== undefined) {
            fetchCityMap({
                lat: lat,
                lon: lon,
                width: width,
                height: height
            });
        }
    }, [
        lat,
        lon,
        width,
        height,
        fetchCityMap
    ]);
    return {
        cityMapURL: cityMapURL,
        fetchCityMap: fetchCityMap
    };
};
/* harmony default export */ var hooks_useFetchCityMap = (useFetchCityMap);

// EXTERNAL MODULE: ./src/hooks/usePrePopPrepaidSearch.ts
var usePrePopPrepaidSearch = __webpack_require__(57608);
// EXTERNAL MODULE: ./src/context/ExperimentContext.tsx
var ExperimentContext = __webpack_require__(68374);
// EXTERNAL MODULE: ./src/hooks/useGA4Analytics.ts + 3 modules
var useGA4Analytics = __webpack_require__(8176);
// EXTERNAL MODULE: ./src/context/SearchFormContext.tsx
var SearchFormContext = __webpack_require__(51069);
// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/utils.ts
var utils = __webpack_require__(84822);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 31 modules
var es = __webpack_require__(57420);
;// CONCATENATED MODULE: ./src/components/Hotels/SearchForm/validation.ts


var LOCATION_REQUIRED = "Please enter your City, Airport, Point of Interest, Hotel Name or U.S. Zip Code";
var PKG_LOCATION_REQUIRED = "Please enter a city or airport";
var PKG_LOCATION_INCORRECT = "Please select a city or airport to add a flight to your hotel";
var INVALID_DATE = "Please select valid dates";
var DISALLOW_INFANT_INTL_FLIGHT = "Sorry, we do not offer lap infant seating on international flights";
var INFANT_CAPACITY_LIMIT = "Only one infant per adult is allowed";
var CHILD_AGE_REQUIRED = "Please enter children's age to get the best price for your group";
var TRAVELERS_PER_ROOM = 4;
var MAXIMUM_BUNDLE_GUEST_COUNT = 8;
var ROOM_CAPACITY_ERROR = "Rooms accommodate up to 4 people. You may need additional rooms for your group";
var BUNDLE_MAX_CAPACITY_ERROR = "Bundles accommodate up to 8 people. You may need an additional bundle for your group";
var intlLocation = function(locationObject) {
    return locationObject && typeof locationObject.countryCode === "string" && locationObject.countryCode.toUpperCase() !== "US";
};
var isInfantFound = function(childrenAges) {
    return Array.isArray(childrenAges) && childrenAges.some(function(age) {
        return Number(age) === 0;
    });
};
var isLocationWithInfant = function(locationObject, childrenAges) {
    return intlLocation(locationObject) && isInfantFound(childrenAges);
};
var isChildrenAgeDataValid = function(childrenAges) {
    return Array.isArray(childrenAges);
};
var numOfValidAges = function(childrenAges) {
    if (Array.isArray(childrenAges)) {
        return childrenAges.filter(function(age) {
            return age >= 0;
        });
    }
    return [];
};
var isInfantOnInternationalTravel = function(location, childrenAges) {
    return isLocationWithInfant(location, childrenAges);
};
function isChildrenAgeNotProvided(childrenCount, childrenAges) {
    return childrenCount > 0 && isChildrenAgeDataValid(childrenAges) && childrenCount !== numOfValidAges(childrenAges).length;
}
var isInfantLimitReachedPackages = function(adultCount, childrenAges, tripType) {
    var lapInfants = childrenAges.filter(function(age) {
        return age === 0;
    });
    var infantCount = lapInfants.length;
    return tripType.includes(Hotels_constants/* FLY */.wd) && infantCount > adultCount;
};
function handleInfantChildrenTravel() {
    var _parent = this.parent, adultCount = _parent.adultCount, childrenAges = _parent.childrenAges, startLocation = _parent.startLocation, endLocation = _parent.endLocation, childrenCount = _parent.childrenCount, tripType = _parent.tripType;
    if (tripType.includes(Hotels_constants/* FLY */.wd) && (isInfantOnInternationalTravel(endLocation, childrenAges) || isInfantOnInternationalTravel(startLocation, childrenAges))) {
        return this.createError({
            message: DISALLOW_INFANT_INTL_FLIGHT,
            path: this.path
        });
    }
    if (isInfantLimitReachedPackages(adultCount, childrenAges, tripType)) {
        return this.createError({
            message: INFANT_CAPACITY_LIMIT,
            path: this.path
        });
    }
    if (isChildrenAgeNotProvided(childrenCount, childrenAges)) {
        return this.createError({
            message: CHILD_AGE_REQUIRED,
            path: this.path
        });
    }
    return true;
}
function handleRoomCapacity() {
    var _parent = this.parent, adultCount = _parent.adultCount, roomCount = _parent.roomCount, childrenCount = _parent.childrenCount, tripType = _parent.tripType;
    var isMoreRoomCapacityAllowed = (this.options.context || {}).isMoreRoomCapacityAllowed;
    var travelerCount = adultCount + childrenCount;
    var allowedTravelerCount = isMoreRoomCapacityAllowed ? MAXIMUM_BUNDLE_GUEST_COUNT : roomCount * TRAVELERS_PER_ROOM;
    if (allowedTravelerCount < travelerCount && tripType.includes(Hotels_constants/* FLY */.wd)) {
        return this.createError({
            message: isMoreRoomCapacityAllowed ? BUNDLE_MAX_CAPACITY_ERROR : ROOM_CAPACITY_ERROR,
            path: this.path
        });
    }
    return true;
}
function handlePackageLocation() {
    var endLocation = this.parent.endLocation;
    if (!endLocation) {
        return this.createError({
            message: PKG_LOCATION_REQUIRED,
            path: this.path
        });
    }
    if (endLocation.type !== "CITY" && endLocation.type !== "AIRPORT" && endLocation.type !== "GEO") {
        return this.createError({
            message: PKG_LOCATION_INCORRECT,
            path: this.path
        });
    }
    return true;
}
var searchFormSchema = es/* object */.Ry().shape({
    tripType: es/* string */.Z_(),
    partialStay: es/* bool */.Xg(),
    startLocation: es/* object */.Ry().nullable().when("tripType", {
        is: function(tripType) {
            return tripType.includes(Hotels_constants/* FLY */.wd);
        },
        then: es/* object */.Ry().nullable().required(PKG_LOCATION_REQUIRED),
        otherwise: es/* object */.Ry().nullable()
    }),
    endLocation: es/* object */.Ry().nullable().when("tripType", {
        is: function(tripType) {
            return tripType.includes(Hotels_constants/* FLY */.wd);
        },
        then: es/* object */.Ry().nullable().test({
            name: "endLocationPkg",
            test: handlePackageLocation
        }),
        otherwise: es/* object */.Ry().nullable().required(LOCATION_REQUIRED)
    }),
    startDate: es/* string */.Z_().required(INVALID_DATE),
    endDate: es/* string */.Z_().required(INVALID_DATE),
    childrenCount: es/* number */.Rx().test({
        name: "childrenCount",
        test: handleInfantChildrenTravel
    }),
    roomCount: es/* number */.Rx().test({
        name: "roomCount",
        test: handleRoomCapacity
    })
});

;// CONCATENATED MODULE: ./src/components/Hotels/SearchForm/Form.tsx



function Form_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n"
    ]);
    Form_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: ",
        "px;\n  right: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







































var StyledRelative = (0,styled_components_browser_esm/* default */.ZP)(Relative/* default */.Z).withConfig({
    componentId: "sc-7100404a-0"
})(Form_templateObject());
var StyledAbsolute = (0,styled_components_browser_esm/* default */.ZP)(Absolute/* default */.Z).withConfig({
    componentId: "sc-7100404a-1"
})(_templateObject1(), (0,index_esm/* themeGet */.R)("space.4"), (0,index_esm/* themeGet */.R)("space.3"));
function Form(param) {
    var onSubmit = param.onSubmit, promoDeal = param.promoDeal, setHasDateChanged = param.setHasDateChanged, _setLocation = param.setLocation, setLocation = _setLocation === void 0 ? function() {
    // if pre-pop isn't used
    } : _setLocation;
    var registerAmbiguousElement = function registerAmbiguousElement(ref) {
        ambiguousElement.current = ref;
    };
    var ref;
    var ref1 = (0,react.useState)(false), isHotelCalendarOpen = ref1[0], setIsHotelCalendarOpen = ref1[1];
    var ref2 = (0,useTabGroup/* default */.Z)(), registerTabElement = ref2.registerTabElement, focusNextElement = ref2.focusNextElement;
    var ref3 = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref3.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, prePopData = ref3.prePopData, webstats = ref3.webstats, customer = ref3.customer;
    var updateFormValues = (0,react.useContext)(SearchFormContext/* SearchFormContext */.j).updateFormValues;
    var prePaidPrePop = (0,usePrePopPrepaidSearch/* default */.Z)();
    var ref4, ref5;
    var ref6 = (ref5 = (ref4 = prePopData === null || prePopData === void 0 ? void 0 : prePopData.hotels) !== null && ref4 !== void 0 ? ref4 : prePaidPrePop) !== null && ref5 !== void 0 ? ref5 : {}, endLocation = ref6.endLocation, prePopStartDate = ref6.startDate, prePopEndDate = ref6.endDate, roomCount = ref6.roomCount;
    var ref7 = (0,react.useState)(false), isStickyInEffect = ref7[0], setIsStickyInEffect = ref7[1];
    var enableStickyEffect = !isMobile && !promoDeal;
    var ref8 = (0,router.useRouter)(), query = ref8.query, pathname = ref8.pathname;
    var isHomepage = pathname === "/";
    var ANALYTICS_CATEGORY = constants_analytics/* ANALYTICS_CATEGORIES */.ZP[pathname];
    var ORIGINAL_MOBILE_CITY_MAP_HEIGHT = 130;
    var MOBILE_CITY_MAP_HEIGHT_CONTAINER = 80;
    var SEMSearch = query.SEMSearch, SEMSEARCH = query.SEMSEARCH, ambigHotelCity = query["ambig-hotel-city"];
    var initialValues = (0,_object_spread/* default */.Z)({}, utils/* initialState */.E3, endLocation && {
        endLocation: endLocation
    }, prePopStartDate && {
        startDate: prePopStartDate
    }, prePopEndDate && {
        endDate: prePopEndDate
    }, roomCount && {
        roomCount: roomCount
    });
    var isMoreRoomCapacityAllowed = (0,useSeti/* default */.Z)("PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION", false) === "VARIANT";
    var isMobileFormInputSmaller = isMobile && !isHomepage;
    // eslint-disable can be removed after upgrade to react-hook-form v7 - https://github.com/react-hook-form/react-hook-form/issues/2887
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var ref9 = (0,react_hook_form_es/* useForm */.cI)({
        defaultValues: initialValues,
        mode: "onSubmit",
        validationSchema: searchFormSchema,
        reValidateMode: "onChange",
        validationContext: {
            isMoreRoomCapacityAllowed: isMoreRoomCapacityAllowed
        }
    }), clearError = ref9.clearError, register = ref9.register, unregister = ref9.unregister, setValue = ref9.setValue, getValues = ref9.getValues, handleSubmit = ref9.handleSubmit, watch = ref9.watch, triggerValidation = ref9.triggerValidation, errors = ref9.errors;
    var ref10 = (0,react.useState)(undefined), cityMapWidth = ref10[0], setCityMapWidth = ref10[1];
    (0,react.useEffect)(function() {
        setCityMapWidth(window.screen.width);
    }, []);
    (0,react.useEffect)(function() {
        utils/* fields.forEach */.XU.forEach(function(name) {
            register({
                name: name
            });
        });
        return function() {
            utils/* fields.forEach */.XU.forEach(function(name) {
                unregister(name);
            });
        };
    }, [
        register,
        unregister
    ]);
    var ref11 = watch(), watchEndLocation = ref11.endLocation, watchStartLocation = ref11.startLocation, watchStartDate = ref11.startDate, watchEndDate = ref11.endDate, watchRoomCount = ref11.roomCount, watchAdultCount = ref11.adultCount, watchChildrenAges = ref11.childrenAges, watchChildrenCount = ref11.childrenCount, watchTripType = ref11.tripType;
    (0,react.useEffect)(function() {
        if (watchEndLocation) {
            setLocation(watchEndLocation);
        }
    }, [
        watchEndLocation,
        setLocation
    ]);
    // PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION
    (0,react.useEffect)(function() {
        if (watchTripType.includes(Hotels_constants/* FLY */.wd) && (0,packages_room_count/* default */.Z)(watchRoomCount, watchAdultCount + watchChildrenCount)) {
            esm/* default.fireImpression */.Z.fireImpression("PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION");
        }
    }, [
        watchTripType,
        watchRoomCount,
        watchAdultCount,
        watchChildrenCount
    ]);
    var logGA4Event = (0,useGA4Analytics/* default */.Z)("MKTG_MWEB_HTL_PROD_HP_APP_MODAL").logGA4Event;
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (isMobile && !isHomepage && (window === null || window === void 0 ? void 0 : (ref = window.PCLN) === null || ref === void 0 ? void 0 : (ref1 = ref.pclnEventDispatcher) === null || ref1 === void 0 ? void 0 : ref1.dispatch)) {
            esm/* default.fireImpression */.Z.fireImpression("MKTG_MWEB_HTL_PROD_HP_APP_MODAL");
            logGA4Event();
        }
    }, [
        logGA4Event,
        isMobile,
        isHomepage
    ]);
    var MKTG_MWEB_HTL_PROD_HP_APP_MODAL = (0,react.useContext)(ExperimentContext/* default */.Z).MKTG_MWEB_HTL_PROD_HP_APP_MODAL;
    var searchBtnText = useCityNameInBtnTextExperiment(watchTripType, watchEndLocation);
    var hasFlight = watchTripType.includes(Hotels_constants/* FLY */.wd);
    var hasCar = watchTripType.includes(Hotels_constants/* DRIVE */.cv);
    var isHPWithoutStickyEffect = isHomepage && !isStickyInEffect;
    var HTL_MAX_DAYS_ALLOWED = (0,useSeti/* default */.Z)("HTL_MAX_DAYS_ALLOWED", false);
    var maxDaysToSelect = HTL_MAX_DAYS_ALLOWED === "VARIANT" ? 32 : 30;
    var ref12;
    var ref13 = (ref12 = prePopData === null || prePopData === void 0 ? void 0 : (ref = prePopData.hotels) === null || ref === void 0 ? void 0 : ref.endLocation) !== null && ref12 !== void 0 ? ref12 : {}, lat = ref13.lat, lon = ref13.lon, cityName = ref13.cityName;
    var showCityMapInMobile = isMobile && !hasFlight && !hasCar && !isHomepage && !!cityName;
    var showCityDisambiguation = !!ambigHotelCity && !!cityName && !isHomepage;
    var ref14 = hooks_useFetchCityMap(showCityMapInMobile ? {
        lat: lat,
        lon: lon,
        width: cityMapWidth,
        height: ORIGINAL_MOBILE_CITY_MAP_HEIGHT
    } : {
        lat: undefined,
        lon: undefined,
        width: undefined,
        height: undefined
    }), cityMapURL = ref14.cityMapURL, fetchCityMap = ref14.fetchCityMap;
    var inputFormMargin = !isMobile || isMobileFormInputSmaller ? 3 : "12px";
    (0,react.useEffect)(function() {
        if (!prePopData && prePaidPrePop) {
            setValue("startDate", prePaidPrePop === null || prePaidPrePop === void 0 ? void 0 : prePaidPrePop.startDate);
            setValue("endDate", prePaidPrePop === null || prePaidPrePop === void 0 ? void 0 : prePaidPrePop.endDate);
            setValue("endLocation", prePaidPrePop === null || prePaidPrePop === void 0 ? void 0 : prePaidPrePop.endLocation);
        }
    }, [
        prePaidPrePop,
        prePopData,
        setValue
    ]);
    (0,react.useEffect)(function() {
        var shouldPopulateDates = !watchStartDate && !watchEndDate;
        var start = shouldPopulateDates ? (0,format/* default */.Z)(new Date(), "yyyyMMdd") : watchStartDate;
        var end = shouldPopulateDates ? (0,format/* default */.Z)((0,addDays/* default */.Z)(new Date(), 1), "yyyyMMdd") : watchEndDate;
        if (shouldPopulateDates) {
            setValue("startDate", start);
            setValue("endDate", end);
        }
    }, [
        setValue,
        watchStartDate,
        watchEndDate
    ]);
    var isOneLineSearch = !isMobile && !promoDeal && (isStickyInEffect || !isHomepage) && (isStickyInEffect || !hasFlight);
    var smbtBtnReplacementGrid = isHPWithoutStickyEffect ? 1 / 2 : 1 / 3;
    var smbtBtnReplacementGridRow2 = isHPWithoutStickyEffect ? 1 / 2 : 2 / 5;
    var smbtBtnReplacementGridRow3 = isHPWithoutStickyEffect ? 1 / 2 : 1 / 5;
    var smbtBtnReplacementGridTypeAhead = isHPWithoutStickyEffect ? 1 : 1 / 2;
    var marginBottomButtonWithoutStickySearch = 3;
    var marginBottomButtonStickySearch = [
        4,
        null,
        3
    ];
    var marginButtonBasedOnStickySearch = isStickyInEffect ? marginBottomButtonStickySearch : marginBottomButtonWithoutStickySearch;
    var searchBtnMargin = !isMobile && isHPWithoutStickyEffect ? 1 : marginButtonBasedOnStickySearch;
    // eslint-disable-next-line no-nested-ternary
    var typeaheadWidth = isOneLineSearch ? hasFlight ? [
        1,
        null,
        24 / 100
    ] : [
        1,
        null,
        27 / 100
    ] : hasFlight ? [
        1,
        null,
        1 / 2,
        null,
        1 / 2
    ] : [
        1,
        null,
        smbtBtnReplacementGridTypeAhead,
        null,
        1
    ];
    // eslint-disable-next-line no-nested-ternary
    var calendarWidth = isOneLineSearch ? hasFlight ? [
        1,
        null,
        24 / 100
    ] : [
        1,
        null,
        31 / 100
    ] : hasFlight ? [
        1,
        null,
        smbtBtnReplacementGridRow2,
        null,
        smbtBtnReplacementGrid
    ] : [
        1,
        null,
        1 / 2,
        null,
        smbtBtnReplacementGrid
    ];
    // eslint-disable-next-line no-nested-ternary
    var roomSelectionWidth = isOneLineSearch ? hasFlight ? [
        1,
        null,
        18 / 100
    ] : [
        1,
        null,
        23 / 100
    ] : hasFlight ? [
        1,
        null,
        smbtBtnReplacementGridRow2,
        null,
        smbtBtnReplacementGrid
    ] : [
        1,
        null,
        1 / 2,
        null,
        smbtBtnReplacementGrid
    ];
    // eslint-disable-next-line no-nested-ternary
    var searchButtonWidth = isOneLineSearch ? hasFlight ? [
        1,
        null,
        10 / 100
    ] : [
        1,
        null,
        19 / 100
    ] : hasFlight ? [
        1,
        null,
        smbtBtnReplacementGridRow3,
        null,
        smbtBtnReplacementGrid
    ] : [
        1,
        null,
        1 / 2,
        null,
        smbtBtnReplacementGrid
    ];
    // eslint-disable-next-line no-nested-ternary
    var packageOptionsWidth = isOneLineSearch ? hasFlight ? [
        1,
        null,
        10 / 100
    ] : [
        1,
        null,
        19 / 100
    ] : [
        1,
        null,
        1 / 2,
        null,
        1 / 2
    ];
    var hotelPlannerLink = (0,utils/* groupDealsURL */.DE)({
        location: watchEndLocation ? watchEndLocation.itemName : "",
        startDate: watchStartDate,
        endDate: watchEndDate
    });
    var hotelPlannerLinkAttrsProp = {
        href: hotelPlannerLink,
        target: "_blank"
    };
    var handleShowBundleAndSaveWidth = // eslint-disable-next-line no-nested-ternary
    isHPWithoutStickyEffect && !isMobile ? packageOptionsWidth : isMobile ? "100%" : "";
    var handleStickyEffectStateChange = function(param) {
        var status = param.status;
        if (status === (Sticky_default()).STATUS_FIXED && !isStickyInEffect) {
            setIsStickyInEffect(true);
        } else if (isStickyInEffect) {
            setIsStickyInEffect(false);
        }
    };
    var showBundleAndSave = function() {
        return !promoDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            width: handleShowBundleAndSaveWidth,
            px: isHPWithoutStickyEffect && !isMobile && 2,
            py: [
                2,
                null,
                0
            ],
            mb: isMobile || !isHPWithoutStickyEffect ? 3 : 4,
            height: 56,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundleAndSave/* default */.Z, {
                category: ANALYTICS_CATEGORY,
                productOptions: Hotels_constants/* ADD_PRODUCT_OPTIONS */.Po,
                tripType: watchTripType,
                label: "Bundle + Save",
                setValue: setValue
            })
        });
    };
    var showCurrentLocation = !promoDeal && isMobile;
    (0,react.useEffect)(function() {
        clearError("startLocation");
    }, [
        clearError,
        watchStartLocation
    ]);
    (0,react.useEffect)(function() {
        clearError("endLocation");
    }, [
        clearError,
        watchEndLocation
    ]);
    (0,react.useEffect)(function() {
        clearError("startDate");
    }, [
        clearError,
        watchStartDate
    ]);
    (0,react.useEffect)(function() {
        clearError("endDate");
    }, [
        clearError,
        watchEndDate
    ]);
    (0,react.useEffect)(function() {
        triggerValidation("childrenCount");
    }, [
        triggerValidation,
        watchStartLocation,
        watchEndLocation,
        watchChildrenAges,
        watchAdultCount,
        watchChildrenCount
    ]);
    (0,react.useEffect)(function() {
        triggerValidation("roomCount");
    }, [
        triggerValidation,
        watchChildrenCount,
        watchRoomCount,
        watchAdultCount,
        watchTripType
    ]);
    (0,react.useEffect)(function() {
        if (updateFormValues) {
            updateFormValues(getValues());
        }
    }, [
        getValues,
        updateFormValues,
        watchStartLocation,
        watchEndLocation,
        watchStartDate,
        watchEndDate,
        watchChildrenAges,
        watchAdultCount,
        watchChildrenCount,
        watchRoomCount,
        watchTripType
    ]);
    (0,react.useEffect)(function() {
        if (!(0,isEmpty/* default */.Z)(errors)) {
            var label = "".concat(constants_analytics/* INVALID */.UI, " - ").concat((0,join/* default */.Z)(" | ", (0,keys/* default */.Z)(errors)));
            analytics/* default.fireEvent */.Z.fireEvent({
                action: isStickyInEffect ? "Hotel Sticky Search Button" : constants_analytics/* ANALYTICS_ACTION_HOTELS_SEARCH */.h0,
                category: ANALYTICS_CATEGORY,
                label: label
            });
        }
    }, [
        errors,
        ANALYTICS_CATEGORY,
        isStickyInEffect
    ]);
    var itemSelected = (0,react.useCallback)(function(item) {
        var gaTracking = function() {
            analytics/* default.fireEvent */.Z.fireEvent({
                action: "Field click",
                category: ANALYTICS_CATEGORY,
                label: "Typeahead"
            });
        };
        if (item) {
            gaTracking();
        }
        if (setHasDateChanged) setHasDateChanged(true);
        if (showCityMapInMobile && item) {
            fetchCityMap({
                lat: item === null || item === void 0 ? void 0 : item.lat,
                lon: item === null || item === void 0 ? void 0 : item.lon,
                width: window.screen.width,
                height: ORIGINAL_MOBILE_CITY_MAP_HEIGHT
            });
        }
        if (!isMobile && !!item) {
            focusNextElement();
        } else if (isMobile && !!item && document.activeElement) {
            document.activeElement.blur();
        }
    }, [
        setHasDateChanged,
        showCityMapInMobile,
        isMobile,
        ANALYTICS_CATEGORY,
        fetchCityMap,
        focusNextElement
    ]);
    var ambiguousElement = (0,react.useRef)();
    var clarifyAmbiguity = (0,react.useCallback)(function() {
        var ref;
        var city = (ref = endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName) !== null && ref !== void 0 ? ref : "";
        return setTimeout(function() {
            if (ambiguousElement.current && city) {
                ambiguousElement.current.focus();
                var ambiguousCity = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, endLocation), {
                    itemName: city
                });
                setValue("endLocation", ambiguousCity);
            }
        }, 0);
    }, [
        endLocation,
        setValue
    ]);
    var showVPDisclaimer = watchTripType.includes(Hotels_constants/* FLY */.wd) || watchTripType.includes(Hotels_constants/* DRIVE */.cv);
    var HP_LP_BUTTON_MICROANIMATION = (0,useSeti/* default */.Z)("HOTELS_LP_BUTTON_MICROANIMATION", !(isHomepage && !isMobile));
    var htlButtonMicroAnimation = isHomepage && !isMobile || HP_LP_BUTTON_MICROANIMATION === "VARIANT";
    var htlButtonMicroAnimationProps = htlButtonMicroAnimation ? {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        scale: theme/* theme.scale.scale-100 */.rS.scale["scale-100"] + theme/* theme.scale.scale-2 */.rS.scale["scale-2"],
        animatedBoxShadow: theme/* theme.shadows.xl */.rS.shadows.xl
    } : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        "data-testid": promoDeal ? "express-deal-form" : "form",
        "aria-label": promoDeal ? "hotel-express-deal-search-form" : "hotel-search-form",
        onSubmit: handleSubmit(function(data) {
            return onSubmit((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                gaCategory: ANALYTICS_CATEGORY
            }), SEMSearch && {
                SEMSearch: SEMSearch
            }, SEMSEARCH && {
                SEMSEARCH: SEMSEARCH
            }), {
                gaAction: isStickyInEffect ? "Hotel Sticky Search Button" : constants_analytics/* ANALYTICS_ACTION_HOTELS_SEARCH */.h0,
                mapView: false
            }));
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyEffect, {
                enabled: enableStickyEffect,
                isStickyInEffect: isStickyInEffect,
                handleStickyEffectStateChange: handleStickyEffectStateChange,
                stickyHeight: 120,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mx: -2,
                    flexWrap: [
                        "wrap",
                        isOneLineSearch ? null : "wrap"
                    ],
                    children: [
                        hasFlight && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: typeaheadWidth,
                            mb: inputFormMargin,
                            pl: 2,
                            pr: isOneLineSearch ? 1 : 2,
                            "data-testid": "DASH_TAB_HOTELS_STARTLOCATION",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                forProperty: "location",
                                children: function(param) {
                                    var disableShadowState = param.disableShadowState;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        textAlign: "left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                            searchProduct: "packagesOrigin",
                                            label: "Where from?",
                                            placeholder: "Where from?",
                                            searchKey: "startLocation",
                                            setValue: setValue,
                                            errors: errors,
                                            disableShadowState: disableShadowState,
                                            defaultSelectedItem: watchStartLocation,
                                            ref: registerTabElement,
                                            showCurrentLocation: showCurrentLocation,
                                            onItemSelect: itemSelected
                                        })
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            width: typeaheadWidth,
                            mb: showCityDisambiguation ? 1 : inputFormMargin,
                            pl: hasFlight && isOneLineSearch ? 1 : 2,
                            pr: isOneLineSearch ? 1 : 2,
                            "data-testid": "DASH_TAB_HOTELS_ENDLOCATION",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                    forProperty: "location",
                                    children: function(param) {
                                        var disableShadowState = param.disableShadowState;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            textAlign: "left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                searchProduct: hasFlight ? "packagesDestination" : "hotels",
                                                label: "Where to?",
                                                placeholder: "Where to?",
                                                searchKey: "endLocation",
                                                setValue: setValue,
                                                errors: errors,
                                                disableShadowState: disableShadowState,
                                                defaultSelectedItem: watchEndLocation,
                                                ref: function(elem) {
                                                    registerTabElement(elem);
                                                    if (showCityDisambiguation) {
                                                        registerAmbiguousElement(elem);
                                                    }
                                                },
                                                showCurrentLocation: showCurrentLocation,
                                                onItemSelect: itemSelected
                                            })
                                        });
                                    }
                                }),
                                showCityDisambiguation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    py: [
                                        2,
                                        null,
                                        1
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                        variation: "link",
                                        onClick: function(e) {
                                            e.preventDefault();
                                            clarifyAmbiguity();
                                            analytics/* default.fireEvent */.Z.fireEvent({
                                                action: "ambiguous-city",
                                                category: ANALYTICS_CATEGORY,
                                                label: cityName
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                            fontSize: 0,
                                            children: [
                                                "Looking for a different ",
                                                cityName,
                                                "?"
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: calendarWidth,
                            mb: inputFormMargin,
                            px: isOneLineSearch ? 1 : 2,
                            "data-testid": "DASH_TAB_HOTELS_DATES",
                            id: "hotel-date-range-box",
                            textAlign: "left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                forProperty: "hotel-date-range",
                                children: function(param) {
                                    var disableShadowState = param.disableShadowState;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                        open: isHotelCalendarOpen,
                                        "data-calendar": true,
                                        onDismiss: function() {
                                            setIsHotelCalendarOpen(false);
                                            disableShadowState();
                                        },
                                        domSelectorForVisuallyContainedElement: Hotels_constants/* CALENDAR_POPOVER_SELECTOR */.k7,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                id: "hotel-date-range",
                                                "data-testid": "hotel-date-range",
                                                m: 0,
                                                ref: registerTabElement,
                                                "aria-expanded": isHotelCalendarOpen ? "true" : "false",
                                                error: function() {
                                                    if (errors.startDate) {
                                                        return errors.startDate.message;
                                                    }
                                                    if (errors.endDate) {
                                                        return errors.endDate.message;
                                                    }
                                                }(),
                                                label: "Check-in - Check-out",
                                                name: "hotelDates",
                                                onFocus: function() {
                                                    esm/* default.fireImpression */.Z.fireImpression("HTL_MAX_DAYS_ALLOWED");
                                                    setIsHotelCalendarOpen(true);
                                                },
                                                value: (0,date_helper/* getHotelDateRange */.vD)({
                                                    startDate: watchStartDate,
                                                    endDate: watchEndDate
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* Calendar */.f, {
                                                    roundedCorners: true,
                                                    startDate: watchStartDate,
                                                    endDate: watchEndDate,
                                                    maxDaysToSelect: maxDaysToSelect,
                                                    monthWidthPx: 350,
                                                    onChange: function(_, param) {
                                                        var startDate = param.startDate, endDate = param.endDate;
                                                        if (startDate && endDate) {
                                                            setIsHotelCalendarOpen(false);
                                                            disableShadowState();
                                                        }
                                                        if (setHasDateChanged) setHasDateChanged(true);
                                                        setValue("startDate", startDate || "");
                                                        setValue("endDate", endDate || "");
                                                    },
                                                    monthsToShow: 2,
                                                    onDismiss: function() {
                                                        setIsHotelCalendarOpen(false);
                                                        disableShadowState();
                                                    },
                                                    useDefaultFooter: true
                                                })
                                            })
                                        ]
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: roomSelectionWidth,
                            mb: 3,
                            px: isOneLineSearch ? 1 : 2,
                            "data-testid": "DASH_TAB_HOTELS_NUMROOMS",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                enabled: true,
                                forProperty: "travelers-selection-readonly-input",
                                alternativeBlurHandling: true,
                                children: function(param) {
                                    var disableShadowState = param.disableShadowState;
                                    var ref, ref1;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TravelerSelection/* default */.Z, {
                                        adultCount: watchAdultCount,
                                        childrenAges: watchChildrenAges,
                                        childrenCount: watchChildrenCount,
                                        disableShadowState: disableShadowState,
                                        hotelPlannerLinkAttrs: hotelPlannerLinkAttrsProp,
                                        disclaimer: showVPDisclaimer ? constants/* VP_DISCLAIMER */.sP : "",
                                        isMobile: isMobile && isMobileFormInputSmaller,
                                        error: (errors === null || errors === void 0 ? void 0 : (ref = errors.childrenCount) === null || ref === void 0 ? void 0 : ref.message) || (errors === null || errors === void 0 ? void 0 : (ref1 = errors.roomCount) === null || ref1 === void 0 ? void 0 : ref1.message) || isInfantLimitReachedPackages(watchAdultCount, watchChildrenAges, watchTripType) && INFANT_CAPACITY_LIMIT || "",
                                        infantCount: 0,
                                        maxAdults: watchTripType === Hotels_constants/* STAY */.hQ ? 28 : undefined,
                                        maxChildren: watchTripType === Hotels_constants/* STAY */.hQ ? 8 : undefined,
                                        maxRooms: watchTripType === Hotels_constants/* STAY */.hQ ? 9 : undefined,
                                        onDoneButtonClick: disableShadowState,
                                        roomCount: watchRoomCount,
                                        setValue: setValue,
                                        showChildAgeSelectors: true,
                                        showInfantMenuItem: false,
                                        showRoomMenuItem: true,
                                        showSubLabel: false,
                                        showYouthMenuItem: false,
                                        youthCount: 0
                                    });
                                }
                            })
                        }),
                        (isMobile || isHPWithoutStickyEffect) && showBundleAndSave(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            width: searchButtonWidth,
                            pl: isOneLineSearch ? 1 : 2,
                            pr: 2,
                            mb: showCityMapInMobile ? 0 : searchBtnMargin,
                            ml: "center",
                            style: {
                                "overflow-y": !isMobile && "visible",
                                height: !isMobile && (isStickyInEffect || !isHomepage) && "0px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormButton/* default */.Z, (0,_object_spread/* default */.Z)({
                                    buttonText: searchBtnText,
                                    "data-testid": "HOTELS_SUBMIT_BUTTON",
                                    handleClick: function() {
                                        var ref, ref1;
                                        if (isMobile && !isHomepage && MKTG_MWEB_HTL_PROD_HP_APP_MODAL === "VARIANT" && (window === null || window === void 0 ? void 0 : (ref = window.PCLN) === null || ref === void 0 ? void 0 : (ref1 = ref.pclnEventDispatcher) === null || ref1 === void 0 ? void 0 : ref1.dispatch) !== undefined) {
                                            window.PCLN.pclnEventDispatcher.dispatch("FIND YOUR HOTEL");
                                        }
                                    },
                                    "data-rudder-event": true,
                                    "data-sub-type": "search",
                                    "data-source": isHomepage ? "homepage" : "hotel landing",
                                    "data-parent-product": "STAY",
                                    "data-child-product": watchTripType.split(":").slice(1).join(":"),
                                    "data-cguid": webstats.clientGUID,
                                    "data-email-address": customer.emailAddress
                                }, htlButtonMicroAnimationProps)),
                                promoDeal !== Hotels_constants/* PromoDeal.COLLECTIONS */.cS.COLLECTIONS && promoDeal !== Hotels_constants/* PromoDeal.EXPRESS_DEAL */.cS.EXPRESS_DEAL && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    py: 2,
                                    mt: 1,
                                    textAlign: isMobile || isHPWithoutStickyEffect ? "center" : null,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontSize: 0,
                                        children: "Book a hotel with free cancellation for flexibility"
                                    })
                                })
                            ]
                        }),
                        showCityMapInMobile && cityMapURL !== "None" && (!cityMapURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            "data-testid": "city-map-shimmer",
                            width: 1,
                            mx: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
                                height: MOBILE_CITY_MAP_HEIGHT_CONTAINER,
                                width: 1,
                                borderRadius: "lg"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRelative, {
                            mb: 10,
                            width: 1,
                            height: MOBILE_CITY_MAP_HEIGHT_CONTAINER,
                            borderRadius: "lg",
                            mx: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: cityMapURL,
                                    alt: "Map of ".concat(cityName),
                                    px: 0,
                                    top: "50%",
                                    left: "50%",
                                    width: 1,
                                    height: "auto",
                                    position: "relative",
                                    transform: "translate(-50%, -50%)",
                                    "data-testid": "city-map-image"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAbsolute, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                        size: "small",
                                        "data-testid": "open-map-view",
                                        onClick: handleSubmit(function(data) {
                                            return onSubmit((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                                gaCategory: ANALYTICS_CATEGORY
                                            }), SEMSearch && {
                                                SEMSearch: SEMSearch
                                            }), {
                                                gaAction: isStickyInEffect ? "Hotel Sticky Search Button" : constants_analytics/* ANALYTICS_ACTION_HOTELS_SEARCH */.h0,
                                                mapView: true
                                            }));
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin/* default */.Z, {
                                                    size: 14,
                                                    mr: 1
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                    children: "View Hotels on Map"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })),
                        !isMobile && !isHPWithoutStickyEffect && showBundleAndSave()
                    ]
                }, 0)
            })
        })
    });
}


/***/ }),

/***/ 84822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ handleSubmitForExpressDeals; },
/* harmony export */   "DE": function() { return /* binding */ groupDealsURL; },
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "Ky": function() { return /* binding */ handleSubmitForHotels; },
/* harmony export */   "Uo": function() { return /* binding */ formatShopSearchLink; },
/* harmony export */   "XU": function() { return /* binding */ fields; },
/* harmony export */   "eR": function() { return /* binding */ handleSubmitForNHA; },
/* harmony export */   "nz": function() { return /* binding */ handleSubmitForPricebreakers; },
/* harmony export */   "ty": function() { return /* binding */ handleSubmitForVIPDeals; }
/* harmony export */ });
/* unused harmony export getHotelMultiOccParam */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17563);
/* harmony import */ var _shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57809);
/* harmony import */ var _shared_utils_date_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68511);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94738);
/* harmony import */ var _shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29735);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66487);
/* harmony import */ var _Packages_SearchForm_TripTypes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51217);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69722);











var initialState = {
    endLocation: null,
    startLocation: null,
    startDate: "",
    endDate: "",
    roomCount: 1,
    adultCount: 2,
    childrenCount: 0,
    childrenAges: [],
    tripType: _constants__WEBPACK_IMPORTED_MODULE_7__/* .STAY */ .hQ,
    gaCategory: _constants_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ANALYTICS_CATEGORY_HOTELS */ .T,
    gaAction: _constants_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ANALYTICS_ACTION_HOTELS_SEARCH */ .h0,
    mapView: false
};
var fields = [
    "startLocation",
    "endLocation",
    "startDate",
    "endDate",
    "roomCount",
    "adultCount",
    "childrenCount",
    "childrenAges",
    "tripType",
    "gaCategory"
];
var getHotelMultiOccParam = function(param) {
    var adultCount = param.adultCount, childrenAges = param.childrenAges;
    var childrenCount = childrenAges.length;
    var childrenAgesParam = childrenCount > 0 ? childrenAges.join(",") : "";
    return "/adults/".concat(adultCount).concat(childrenCount > 0 ? "/children/".concat(childrenAgesParam) : "");
};
var baseURL = "https://findgroupdeals.hotelplanner.com/Priceline.cfm?City=";
var groupDealsURL = function(param) {
    var location = param.location, startDate = param.startDate, endDate = param.endDate;
    return "".concat(baseURL).concat(encodeURIComponent(location), "&CheckIn=").concat(encodeURIComponent((0,_shared_utils_date_helper__WEBPACK_IMPORTED_MODULE_2__/* .formatDate */ .p6)(startDate)), "&CheckOut=").concat(encodeURIComponent((0,_shared_utils_date_helper__WEBPACK_IMPORTED_MODULE_2__/* .formatDate */ .p6)(endDate)));
};
var _obj;
var dealTypeUrlMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_7__/* .PromoDeal.EXPRESS_DEAL */ .cS.EXPRESS_DEAL, "/sopq"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_7__/* .PromoDeal.COLLECTIONS */ .cS.COLLECTIONS, "/collections"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_7__/* .PromoDeal.NHA */ .cS.NHA, "/nha"), _obj);
// this is private and used by the submit functions below
var formatHotelsURL = function(param) {
    var endLocation = param.endLocation, startDate = param.startDate, endDate = param.endDate, roomCount = param.roomCount, adultCount = param.adultCount, childrenAges = param.childrenAges, dealType = param.dealType, SEMSearch = param.SEMSearch, SEMSEARCH = param.SEMSEARCH, mapView = param.mapView;
    if (endLocation === null) {
        return;
    }
    var searchType = endLocation.type;
    var updatedSearchType = searchType === "HOTEL" ? "CITY" : searchType;
    var location = searchType === "HOTEL" ? endLocation.cityID : endLocation.id || encodeURIComponent(endLocation.itemName);
    var dealTypeParam = dealType === "EXPRESS_DEAL" || dealType === "COLLECTIONS" || dealType === "NHA" ? dealTypeUrlMap[dealType] : "";
    var multiOcc = getHotelMultiOccParam({
        adultCount: adultCount,
        childrenAges: childrenAges
    });
    var queries = [];
    if (searchType === "HOTEL" && !dealTypeParam) {
        queries.push("preferredhotelids=".concat(endLocation.id));
    }
    if (SEMSearch) {
        queries.push("SEMSearch=".concat(SEMSearch));
    }
    if (SEMSEARCH) {
        queries.push("SEMSEARCH=".concat(SEMSEARCH));
    }
    var query = queries.length ? "?".concat(queries.join("&")) : "";
    var urlDatePart = startDate && endDate ? "/from/".concat(startDate, "/to/").concat(endDate) : "";
    var mapViewPath = mapView ? "mapview/" : "";
    if (updatedSearchType === "POI" || updatedSearchType === "AIRPORT") {
        return "/relax/".concat(mapViewPath, "near/").concat(updatedSearchType.toLowerCase(), "/").concat(location).concat(urlDatePart, "/rooms/").concat(roomCount).concat(dealTypeParam).concat(multiOcc).concat(query);
    }
    return "/relax/".concat(mapViewPath, "in/").concat(location).concat(urlDatePart, "/rooms/").concat(roomCount).concat(dealTypeParam).concat(multiOcc).concat(query);
};
var handleSubmitForHotels = function(values) {
    var roomCount = values.roomCount, startDate = values.startDate, endDate = values.endDate, endLocation = values.endLocation, tripType = values.tripType, startLocation = values.startLocation, adultCount = values.adultCount, childrenCount = values.childrenCount, childrenAges = values.childrenAges, gaCategory = values.gaCategory, gaAction = values.gaAction;
    var multiOccFields = {
        adultCount: adultCount,
        childrenCount: childrenCount,
        childrenAges: childrenAges
    };
    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent({
        category: gaCategory,
        action: gaAction,
        label: "VALID"
    });
    var isPackageSearch = tripType.includes(_Packages_SearchForm_TripTypes__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT */ .qQ) || tripType.includes(_Packages_SearchForm_TripTypes__WEBPACK_IMPORTED_MODULE_6__/* .CAR */ .Ow);
    var hasFlight = tripType.includes(_Packages_SearchForm_TripTypes__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT */ .qQ);
    if (isPackageSearch) {
        var basePackageSearchDetails = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            roomCount: Number(roomCount),
            startDate: startDate,
            endDate: endDate,
            endLocationObject: endLocation,
            tripType: tripType,
            isPartialStayDateValid: false
        }, multiOccFields);
        var flightSearchDetails = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            startLocationObject: startLocation
        }, multiOccFields);
        var packageSearchDetails = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, basePackageSearchDetails, hasFlight ? flightSearchDetails : {});
        (0,_shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(packageSearchDetails);
    } else {
        var url = formatHotelsURL(values);
        if (url) {
            window.open(url);
        }
    }
    (0,_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_4__/* .persistSearchData */ .al)(_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_4__/* .HOTEL_SEARCH_DATA */ .yO, values);
};
var handleSubmitForExpressDeals = function(values) {
    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent({
        category: values.gaCategory,
        action: _constants_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ANALYTICS_ACTION_HOTELS_SEARCH */ .h0,
        label: "Hotel SOPQ Search"
    });
    var url = formatHotelsURL((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, values), {
        dealType: _constants__WEBPACK_IMPORTED_MODULE_7__/* .PromoDeal.EXPRESS_DEAL */ .cS.EXPRESS_DEAL
    }));
    window.open(url);
};
var handleSubmitForVIPDeals = function(values) {
    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent({
        category: _constants_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ANALYTICS_CATEGORY_HOME */ .DG,
        action: "Feature Box Modal",
        label: "Hotel Vip Search Button"
    });
    var url = formatHotelsURL((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, values), {
        dealType: _constants__WEBPACK_IMPORTED_MODULE_7__/* .PromoDeal.VIP */ .cS.VIP
    }));
    window.open(url);
};
var handleSubmitForPricebreakers = function(values) {
    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent({
        category: _constants_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ANALYTICS_CATEGORY_HOME */ .DG,
        action: "Feature Box Modal",
        label: "Hotel Collection Search Button"
    });
    var url = formatHotelsURL((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, values), {
        dealType: _constants__WEBPACK_IMPORTED_MODULE_7__/* .PromoDeal.COLLECTIONS */ .cS.COLLECTIONS
    }));
    window.open(url);
};
var handleSubmitForNHA = function(values) {
    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent({
        category: values.gaCategory,
        action: _constants_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ANALYTICS_ACTION_HOTELS_SEARCH */ .h0,
        label: "Hotel NHA Search"
    });
    var url = formatHotelsURL((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, values), {
        dealType: _constants__WEBPACK_IMPORTED_MODULE_7__/* .PromoDeal.NHA */ .cS.NHA
    }));
    window.open(url);
};
var formatShopSearchLink = function(param) {
    var tripType = param.tripType, startLocation = param.startLocation, endLocation = param.endLocation, startDate = param.startDate, endDate = param.endDate, roomCount = param.roomCount, adultCount = param.adultCount, childrenCount = param.childrenCount, childrenAges = param.childrenAges;
    var stringifiedQuery = query_string__WEBPACK_IMPORTED_MODULE_0__.stringify({
        "flight-code": "RT",
        "trip-type": tripType,
        "origin-item": startLocation === null || startLocation === void 0 ? void 0 : startLocation.itemName,
        "origin-id": startLocation === null || startLocation === void 0 ? void 0 : startLocation.id,
        "origin-type": startLocation === null || startLocation === void 0 ? void 0 : startLocation.type,
        "origin-city": startLocation === null || startLocation === void 0 ? void 0 : startLocation.cityName,
        "origin-state": startLocation === null || startLocation === void 0 ? void 0 : startLocation.provinceName,
        "origin-state-code": startLocation === null || startLocation === void 0 ? void 0 : startLocation.stateCode,
        "origin-country": startLocation === null || startLocation === void 0 ? void 0 : startLocation.country,
        "origin-country-code": startLocation === null || startLocation === void 0 ? void 0 : startLocation.countryCode,
        "destination-item": endLocation === null || endLocation === void 0 ? void 0 : endLocation.itemName,
        "destination-id": endLocation === null || endLocation === void 0 ? void 0 : endLocation.id,
        "destination-type": endLocation === null || endLocation === void 0 ? void 0 : endLocation.type,
        "destination-city": endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName,
        "destination-state": endLocation === null || endLocation === void 0 ? void 0 : endLocation.provinceName,
        "destination-state-code": endLocation === null || endLocation === void 0 ? void 0 : endLocation.stateCode,
        "destination-country": endLocation === null || endLocation === void 0 ? void 0 : endLocation.country,
        "destination-country-code": endLocation === null || endLocation === void 0 ? void 0 : endLocation.countryCode,
        start: startDate,
        end: endDate,
        rooms: roomCount,
        adults: adultCount,
        children: childrenCount,
        ages: JSON.stringify(childrenAges),
        "hotel-start": startDate,
        "hotel-end": endDate,
        openMultiHotel: true
    });
    return "/shop/search/trips/?".concat(stringifiedQuery);
};


/***/ }),

/***/ 69722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oy": function() { return /* binding */ BANNER_TEXT_PRIMARY; },
/* harmony export */   "Po": function() { return /* binding */ ADD_PRODUCT_OPTIONS; },
/* harmony export */   "ZQ": function() { return /* binding */ BANNER_TEXT_SECONDARY; },
/* harmony export */   "cS": function() { return /* binding */ PromoDeal; },
/* harmony export */   "cv": function() { return /* binding */ DRIVE; },
/* harmony export */   "hQ": function() { return /* binding */ STAY; },
/* harmony export */   "k7": function() { return /* binding */ CALENDAR_POPOVER_SELECTOR; },
/* harmony export */   "kt": function() { return /* binding */ PRIMARY_HEADING_FALLBACK; },
/* harmony export */   "wd": function() { return /* binding */ FLY; }
/* harmony export */ });
/* unused harmony exports STAY_DRIVE, STAY_FLY, STAY_FLY_DRIVE, GEO */
var STAY = "STAY";
var FLY = "FLY";
var DRIVE = "DRIVE";
var STAY_DRIVE = "STAY:DRIVE";
var STAY_FLY = "STAY:FLY";
var STAY_FLY_DRIVE = "STAY:FLY:DRIVE";
var ADD_PRODUCT_OPTIONS = [
    {
        name: "car",
        type: DRIVE,
        label: "Add a car",
        id: "add-a-car-checkbox"
    },
    {
        name: "flight",
        type: FLY,
        label: "Add a flight",
        id: "add-a-flight-checkbox"
    }
];
var PromoDeal = {
    EXPRESS_DEAL: "EXPRESS_DEAL",
    COLLECTIONS: "COLLECTIONS",
    VIP: "VIP",
    NHA: "NHA"
};
var CALENDAR_POPOVER_SELECTOR = '[aria-label="Calendar navigation tooltip"]';
var PRIMARY_HEADING_FALLBACK = "Searching for a place to stay?";
var BANNER_TEXT_PRIMARY = "Save up to 60% by searching Express Deals.";
var BANNER_TEXT_SECONDARY = "Incredible deals from independent hotels and well-known brands.";
var GEO = "GEO";


/***/ }),

/***/ 51069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ SearchFormContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var SearchFormContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
function SearchFormProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), formValues = ref[0], updateFormValues = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchFormContext.Provider, {
        value: {
            formValues: formValues,
            updateFormValues: updateFormValues
        },
        children: children
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SearchFormProvider);


/***/ }),

/***/ 57608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePrePopPrepaidSearch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33913);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23855);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51085);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);
/* harmony import */ var _shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29735);






var paidUserRef = [
    "GOOGLECPC",
    "GOOGLECPCB",
    "MSN",
    "MSNB"
];
function usePrePopPrepaidSearch() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), tmp = ref.referral, ref1 = tmp === void 0 ? {} : tmp, _id = ref1.id, id = _id === void 0 ? "" : _id, _sourceId = ref1.sourceId, sourceId = _sourceId === void 0 ? "" : _sourceId, prePopData = ref.prePopData;
    var isPaidUser = sourceId === "PL" && paidUserRef.includes(id);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), recentSearches = ref2[0], setRecentSearches = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        function getSearch() {
            return _getSearch.apply(this, arguments);
        }
        function _getSearch() {
            _getSearch = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                var data, mostRecentSearch;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(isPaidUser && !(prePopData === null || prePopData === void 0 ? void 0 : prePopData.hotels))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_2__/* .getPersistedSearchDataByKeys */ .xl)([
                                    _shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_2__/* .HOTEL_SEARCH_DATA */ .yO
                                ], true)
                            ];
                        case 1:
                            data = _state.sent();
                            mostRecentSearch = data.slice(0, 1).pop() || null;
                            if ((mostRecentSearch === null || mostRecentSearch === void 0 ? void 0 : mostRecentSearch.startDate) && (!(0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(mostRecentSearch.startDate)) || (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(mostRecentSearch.startDate)))) {
                                setRecentSearches(mostRecentSearch);
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return _getSearch.apply(this, arguments);
        }
        getSearch();
    }, [
        isPaidUser,
        prePopData === null || prePopData === void 0 ? void 0 : prePopData.hotels
    ]);
    return recentSearches;
}


/***/ })

}]);